import Base from '@/models/base';

export default class User extends Base {
  id;
  email;
  firstName;
  lastName;
  lastLogin;
  locale;
  role;
  tenantId;
  timezone;

  static hydrate(obj) {
    const user = new User();
    return Object.assign(user, obj);
  }

  get fullName() {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  equals(obj) {
    if (!obj || !this || !(obj instanceof User)) {
      return false;
    }

    return (
      obj.id === this.id &&
      obj.email === this.email &&
      obj.firstName === this.firstName &&
      obj.lastName === this.lastName &&
      obj.lastLogin === this.lastLogin &&
      obj.locale === this.locale &&
      obj.role === this.role &&
      obj.tenantId === this.tenantId &&
      obj.timezone === this.timezone
    );
  }
}
